import { Grid, Typography } from '@mui/material';
import { Checkbox } from '../../../../../components/general/fields/checkbox';
import { SarlaftDeclarationProps } from './props';
import { useSarlaftDeclaration } from './hook';

export const SarlaftDeclaration = (props: SarlaftDeclarationProps) => {
    const { formik } = useSarlaftDeclaration(props);

    return (
        <Grid item xs={12} md={4}>
            <Typography style={{ fontWeight: 'bold', color: '#000' }}>
                Declaración de renta
            </Typography>
            <br />
            <Checkbox
                label="¿Realizó declaraciones de renta el último año?"
                checked={Boolean(formik.values.lastYearTaxReturn)}
                onChange={() => {
                    formik.setFieldValue(
                        'lastYearTaxReturn',
                        !formik.values.lastYearTaxReturn
                    );
                }}
                onBlur={formik.handleBlur}
                errors={formik.errors.lastYearTaxReturn}
            />
        </Grid>
    );
};
